export default __webpack_public_path__ + "static/media/targetabt2.fe8f51f8.jpg";